module.exports = __webpack_public_path__ + "img/yes-or-no-logo.2f5c67e1.png";